interface ISortableAddon {
  position?: number;
  name: string;
}

/**
 * Sorts add-ons by host-set `position`, mirroring the API's `LoadRentalItems`
 * ordering: positive positions first in ascending order, then the `position=0`
 * bucket. Falls back to alphabetical order as a tiebreaker (preserves the
 * previous behavior when every add-on is at position 0).
 */
export const sortAddonsByPosition = (a: ISortableAddon, b: ISortableAddon) => {
  const ap = a.position ?? 0;
  const bp = b.position ?? 0;
  if (ap === 0 && bp !== 0) return 1;
  if (bp === 0 && ap !== 0) return -1;
  if (ap !== bp) return ap - bp;
  return a.name.localeCompare(b.name);
};
